import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSignup = ({ compact = false }) => {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setSubmitting(true);
        try {
            const { data } = await axios.post(`${API}/newsletter/subscribe`, {
                email,
            });
            if (data.status === "already_subscribed") {
                toast.info("Já está subscrito! Obrigado.");
            } else {
                toast.success(
                    "Subscrição confirmada! Vai receber os próximos artigos por email.",
                );
            }
            setEmail("");
        } catch (err) {
            toast.error("Não foi possível subscrever. Tente novamente.");
        } finally {
            setSubmitting(false);
        }
    };

    if (compact) {
        return (
            <form
                onSubmit={submit}
                className="flex gap-2"
                data-testid="newsletter-signup-compact"
            >
                <input
                    type="email"
                    required
                    placeholder="seuemail@exemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1 min-w-0 px-4 py-2.5 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/50"
                    data-testid="newsletter-email"
                />
                <button
                    type="submit"
                    disabled={submitting}
                    className="acd-btn-gradient !py-2.5 !px-5 whitespace-nowrap"
                    data-testid="newsletter-submit"
                >
                    {submitting ? "..." : "Subscrever"}
                </button>
            </form>
        );
    }

    return (
        <div
            className="bg-gradient-to-br from-[var(--acd-navy-900)] to-[var(--acd-navy-800)] rounded-2xl p-10 md:p-14 text-center relative overflow-hidden"
            data-testid="newsletter-signup"
        >
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[var(--acd-orange)]/10 blur-3xl" />
            <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-[var(--acd-blue-600)]/20 blur-3xl" />
            <div className="relative z-10 max-w-2xl mx-auto">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 mb-5">
                    <Mail className="text-[var(--acd-gold)]" size={24} />
                </div>
                <span className="acd-eyebrow">Newsletter</span>
                <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight mt-3 mb-3">
                    Receba os nossos artigos por email
                </h2>
                <p className="text-white/70 mb-8 text-sm md:text-base max-w-lg mx-auto">
                    Análises jurídicas atuais sobre direito imobiliário, laboral,
                    imigração e empresarial — diretamente na sua caixa de
                    entrada, sempre que publicamos.
                </p>
                <form
                    onSubmit={submit}
                    className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
                >
                    <input
                        type="email"
                        required
                        placeholder="o.seu.email@exemplo.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/40 focus:outline-none focus:border-white/40 focus:bg-white/15 transition"
                        data-testid="newsletter-email-main"
                    />
                    <button
                        type="submit"
                        disabled={submitting}
                        className="acd-btn-gradient whitespace-nowrap justify-center"
                        data-testid="newsletter-submit-main"
                    >
                        {submitting ? "A subscrever..." : "Subscrever"}
                        <ArrowRight size={14} />
                    </button>
                </form>
                <p className="text-white/40 text-xs mt-4">
                    Sem spam. Cancele quando quiser em qualquer email.
                </p>
            </div>
        </div>
    );
};

export default NewsletterSignup;
